export class PracticeFileUpload {
  id: number = null
  sort_no: number = null
  title: string = null
  is_publish: boolean = false
  is_personal: boolean = false
  is_uploaded: boolean = false

  constructor(x: any = null){
    if(!x){
      return;
    }
    this.id = x.id;
    this.sort_no = x.sort_no;
    this.title = x.title;
    this.is_publish = x.is_publish;
    this.is_personal = x.is_personal;
    this.is_uploaded = x.is_uploaded;
  }
}

export class PracticeFile {
  id: number
  student_no_character: string
  student_name: string
  is_delete_checked: boolean = false
  is_download_checked: boolean = false

  constructor(x: any){
    this.id = x.id;
    this.student_no_character = x.student_no_character;
    this.student_name = x.student_name;
  }
}